<template>
  <section>
    <button @click="() => visible = true">
      Show Modal
    </button>
    <BeModal
      title="Modal Title"
      :visible.sync="visible"
      :visible-close-button="visibleCloseButton"
      :visible-confirm-button="visibleConfirmButton"
      :visible-cancel-button="visibleCancelButton"
      @click-close-button="onClickCloseButton"
      @click-confirm-button="onClickConfirmButton"
      @click-cancel-button="onClickCancelButton"
    >
      <div style="padding: 20px; font-size: 17px;">
        <input
          type="checkbox"
          v-model="visibleCloseButton"
        >
        Show close button
        <br>
        <input
          type="checkbox"
          v-model="visibleConfirmButton"
        >
        Show confirm button
        <br>
        <input
          type="checkbox"
          v-model="visibleCancelButton"
        >
        Show cancel button
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
      </div>
    </BeModal>
  </section>
</template>

<script>
export default {
  components: {
    BeModal: () => import('@/components/BeModal/BeModal')
  },

  methods: {
    onClickCloseButton (returnObject) {
      if (!confirm('닫기 버튼 클릭, 창을 닫으시겠습니까?')) {
        returnObject.visible = true
      }
    },

    onClickConfirmButton (returnObject) {
      if (!confirm('확인 버튼 클릭, 창을 닫으시겠습니까?')) {
        returnObject.visible = true
      }
    },

    onClickCancelButton (returnObject) {
      if (!confirm('취소 버튼 클릭, 창을 닫으시겠습니까?')) {
        returnObject.visible = true
      }
    }
  },

  data () {
    return {
      visible: false,
      visibleCloseButton: true,
      visibleConfirmButton: true,
      visibleCancelButton: true
    }
  }
}
</script>
